
import React from 'react';

interface AdminSidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({
  activeTab,
  setActiveTab,
  collapsed,
  setCollapsed
}) => {
  const menuItems = [
    { id: 'dashboard', label: '数据概览', icon: 'ri-dashboard-line' },
    { id: 'projects', label: '项目管理', icon: 'ri-folder-line' },
    { id: 'clients', label: '客户管理', icon: 'ri-user-line' },
    { id: 'ai-reports', label: 'AI报表', icon: 'ri-bar-chart-line' },
    { id: 'settings', label: '系统设置', icon: 'ri-settings-line' }
  ];

  return (
    <div className={`fixed left-0 top-0 h-full bg-white shadow-lg transition-all duration-300 z-40 ${
      collapsed ? 'w-16' : 'w-64'
    }`}>
      {/* Logo */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
            <i className="ri-admin-line text-white text-lg"></i>
          </div>
          {!collapsed && (
            <span className="ml-3 text-xl font-bold text-gray-800">管理后台</span>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="mt-6">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`w-full flex items-center px-4 py-3 text-left transition-colors cursor-pointer ${
              activeTab === item.id
                ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-600'
                : 'text-gray-700 hover:bg-gray-50'
            }`}
          >
            <i className={`${item.icon} text-xl`}></i>
            {!collapsed && (
              <span className="ml-3 font-medium">{item.label}</span>
            )}
          </button>
        ))}
      </nav>

      {/* Collapse Toggle */}
      <div className="absolute bottom-4 left-4 right-4">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="w-full flex items-center justify-center p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
        >
          <i className={`ri-${collapsed ? 'arrow-right' : 'arrow-left'}-s-line text-xl`}></i>
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
